import React from 'react'
import { Mutation, ApolloConsumer } from 'react-apollo'
import { VERIFY, ME } from 'operations/User'
import { Input, Submit, Fieldset } from 'components/Form'
import jwtDecode from 'jwt-decode'
import { withRouter } from 'react-router'
import PasswordRequirement from 'components/Password'
import owasp from 'owasp-password-strength-test'

owasp.config({
    allowPassphrases: true,
    maxLength: 128,
    minLength: 10,
    minPhraseLength: 20,
    minOptionalTestsToPass: 4,
})

const requirementErrors = [
    'minLength',
    'maxLength',
    'repeating',
    'lowercase',
    'uppercase',
    'number',
    'special'
]

class Verify extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            password: '',
            errors: '',
            requirements: {
                passphrase: false,
                minLength: false,
                maxLength: true,
                repeating: true,
                lowercase: false,
                uppercase: false,
                number: false,
                special: false
            }
        }

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e) {
        const { name, value } = e.target
        
        if (name === 'password') {
            const owaspResult = owasp.test(value)

            const tests = this.state.requirements
            Object.keys(tests).map((test) => {
                return tests[test] = 'valid'
            })
            owaspResult.failedTests.map((test) => {
                return tests[requirementErrors[test]] = false
            })
        }        

        this.setState({
            [name]: value
        })
    }

    render() {
        const { token } = this.props.match.params 
        const decoded = jwtDecode(token)

        const { minLength, lowercase, uppercase, number, special } = this.state.requirements

        return(
            <ApolloConsumer>
                {client => (

                    <Mutation mutation={ VERIFY } refetchQueries={[{query: ME}]}>
                    {(verify, { data }) => (

                        <form onSubmit={
                            (e) => {
                                e.preventDefault()
                                verify({ 
                                    variables: { 
                                        data: {
                                            password: this.state.password, 
                                            token: token 
                                        } 
                                    } 
                                })
                                .then(({ data }) => {
                                    localStorage.setItem('accessToken', data.verify.accessToken)
                                    localStorage.setItem('refreshToken', data.verify.refreshToken)
                                    const decoded = jwtDecode(data.verify.accessToken)
                                    localStorage.setItem('tokenExpiry', decoded.exp)
                                    client.writeData({ data: { isAuthenticated: true } })
                                    console.log('push')
                                    this.props.history.push('/')
                                })
                                .catch((err) => {
                                    this.setState({
                                        errors: JSON.stringify(err.message)
                                    })
                                })
                            }
                        }>

                            {/* <div className='unauthorized__tagline'>
                            Thanks for verifying your email
                            </div> */}

                            <h2>Account verification</h2>
                            <h1>Let's create a password</h1>

                            <Fieldset>

                                <input type='hidden' name='username' value={ decoded.sub } />

                                <Input type='password' name='password' label='Password' onChange={ this.handleChange } />

                                <PasswordRequirement state={ minLength }>Longer than 10 characters.</PasswordRequirement>
                                <PasswordRequirement state={ lowercase }>More than 1 lowercase letter.</PasswordRequirement>
                                <PasswordRequirement state={ uppercase }>More than 1 uppercase letter.</PasswordRequirement>
                                <PasswordRequirement state={ number }>More than 1 number.</PasswordRequirement>
                                <PasswordRequirement state={ special }>More than 1 special character.</PasswordRequirement>

                                <Submit value='Verify my account' />

                                { this.state.errors }

                            </Fieldset>

                        </form>
                    )}
                    </Mutation>

                )}
            </ApolloConsumer>
        )

    }

}

export default withRouter(Verify)


// WEBPACK FOOTER //
// ./src/containers/Unauthorized/Verify/index.js